<template>
    <div class="dropdown">
        <label v-if="name" :for="id">{{ name }}</label>
        <select v-model="selected" class="form-control" :id="id" @change="onChange">
          <option v-for="option in options" :key="option.value" :value="option.value">{{ option.name }}</option>
        </select>
    </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    id: String,
    name: String,
    options: Array,
    current: [String, Number, Boolean]
  },
  data: () => ({ 'selected': null }),
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  },
  computed: {},
  mounted () {
    this.selected = this.current
  },
  watch: {
    current: function () {
      this.selected = this.current
    }
  }
}
</script>

<style lang="scss">
    @import "./dropdown";
</style>



// WEBPACK FOOTER //
// src/components/Form/Dropdown/dropdown.vue